export const NOOP = (() => {
  // noop
}) as () => any;

export const ASYNC_NOOP = async () => {
  // noop
};
